export default __webpack_public_path__ + "static/media/spintax-gray.0670533f.svg";